/**
 * Hook: Ask RunAI — sends message to Anne Filiz (agent_id=1)
 * Returns response + loading state
 */
import axios from 'axios'
import { useState } from 'react'
import { API_URL } from '../../../config/api'

export interface ChatMessage {
  role: 'user' | 'assistant'
  content: string
  agentName?: string
  timestamp: Date
  cost?: number
  duration?: number
}

export function useAskRunAI() {
  const [messages, setMessages] = useState<ChatMessage[]>([])
  const [loading, setLoading] = useState(false)

  const send = async (text: string) => {
    if (!text.trim() || loading) { return }
    const token = localStorage.getItem('token')
    if (!token) { return }

    const userMsg: ChatMessage = { role: 'user', content: text, timestamp: new Date() }
    setMessages(prev => [...prev, userMsg])
    setLoading(true)

    const start = Date.now()
    try {
      const res = await axios.post(
        `${API_URL}/api/chat/send`,
        { agent_id: 1, message: text },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      const d = res.data as { response?: string; agent_name?: string }
      const duration = (Date.now() - start) / 1000
      const assistantMsg: ChatMessage = {
        role: 'assistant',
        content: d.response ?? '',
        agentName: d.agent_name ?? 'Anne Filiz',
        timestamp: new Date(),
        duration,
      }
      setMessages(prev => [...prev, assistantMsg])
    } catch {
      const errMsg: ChatMessage = {
        role: 'assistant',
        content: 'Connection failed. Please try again.',
        agentName: 'System',
        timestamp: new Date(),
      }
      setMessages(prev => [...prev, errMsg])
    } finally {
      setLoading(false)
    }
  }

  const clear = () => setMessages([])

  return { messages, loading, send, clear }
}
